module.exports = __webpack_public_path__ + "img/cd.e7899ce2.svg";